import PieVisualization from "views/components/visualizations/pie/PieVisualization";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
const validate = hasAtLeastOneMetric("Pie chart");
const pieChart = {
  type: PieVisualization.type,
  displayName: "Pie Chart",
  component: PieVisualization,
  validate
};
export default pieChart;
